module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seB.1bb95d5.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seB.woff
// module id = zwTU
// module chunks = 241